export default __webpack_public_path__ + "static/media/checkbox-minus-box.6ac3eb8d.svg";